import { createSelector } from 'reselect';
import { updateBottomNavIconDesignSelector } from 'selectors/testTarget/offers/updateBottomNavIconDesign/updateBottomNavIconDesignSelector';

const showSelector = createSelector(updateBottomNavIconDesignSelector, updateBottomNavIconDesign => !!updateBottomNavIconDesign.show);

export { showSelector };
